import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import range from 'lodash-es/range';
import { NCmsComponentRowAccordion } from './cms-component-row-accordion.interface';

export function rangeOptions(from: number, to: number): NICmsContentField.IOption<number>[] {
    return range(from, to).map(i => {
        return { key: i, title: i + '' };
    });
}

export const screenSizeOptions = [
    { key: 3, title: 'Large Desktop' },
    { key: 2, title: 'Small Desktop' },
    { key: 1, title: 'Tablet' },
    { key: 0, title: 'Mobile' }
];

export const CMS_COMPONENT_ROW_ACCORDION_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsComponentRowAccordion.ID,
    isAdvanced: true,
    name: 'Row breaking to accordion',
    image: '/common/cms/row-accordion-component.png',
    tags: ['row', 'footer'],
    fields: [
        // general
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        <NICmsContentField.IChoiceField>{
            type: NICmsContentField.EFieldType.choice,
            title: 'Break to accordion on',
            key: 'accordionBreakdown',
            description: 'Choose display size where row should become accordion',
            options: screenSizeOptions,
            default: 0
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'columns',
            title: 'Columns',
            description: 'Columns are displayed in one row till breakdown screen size where they become accordion',
            itemName: 'column',
            fields: [
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Size',
                    key: 'size',
                    description: `Sizes are relative to other columns, column with size 3 is 3 times wider then column with size 1.
                        Columns fill whole page width.`,
                    options: rangeOptions(1, 12),
                    default: 3
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    title: 'Heading',
                    key: 'heading',
                    required: true,
                    description: 'Column heading on top of column or used as accordion section title'
                },
                <NICmsContentField.IComponentsField>{
                    type: NICmsContentField.EFieldType.components,
                    key: 'components',
                    title: 'Components',
                    itemName: 'component',
                    default: []
                }
            ],
            defaultSize: 3
        }
    ]
};
